<script setup lang="ts">
// "{Page} | VoteWise" everywhere a page sets a title; pages without one
// (e.g. Home) show just the brand instead of "VoteWise | VoteWise".
const appName = useRuntimeConfig().public.appName as string;
useHead({
  titleTemplate: (chunk?: string | null) =>
    chunk && chunk !== appName ? `${chunk} | ${appName}` : appName,
});
// VTW-529: emits the Google Analytics tag only when a property id is
// configured for this environment (production). No-op on staging and locally.
useGoogleAnalytics();
// Same gate for the Meta Pixel: production only, via its runtime pixel id.
useMetaPixel();

// Site-wide social/OG defaults; pages layer their own title/description.
useSeoMeta({
  ogSiteName: appName,
  ogType: 'website',
  twitterCard: 'summary',
});
</script>

<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <Toast />
  </div>
</template>

<style lang="scss" scoped>
/* Prevent flash of unstyled content */
#__nuxt {
  opacity: 0;
  transition: opacity 0.2s ease;
}

#__nuxt.is-loaded {
  opacity: 1;
}
</style>
